import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-388e2d4e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "restore-profile-screen" }
const _hoisted_2 = { class: "confirm-wrapper" }
const _hoisted_3 = {
  key: 0,
  class: "address"
}
const _hoisted_4 = {
  key: 1,
  class: "gradient-text"
}
const _hoisted_5 = { class: "address profile-address-single mb-6" }
const _hoisted_6 = { class: "buttons" }

import { ref, Ref, inject } from 'vue'

import RestoreWizard from '@/popup/components/shared/Wizard.vue'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'
import Button from '@/popup/components/shared/Button.vue'
import UserName from '@/popup/components/shared/Miscellaneous/UserName.vue'
import { ProfileDTO } from '@/business-logic/wallet'

type Emits = {
  (event: 'on-restore-confirm'): void
  (event: 'on-restore-cancel'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmMultiple',
  emits: ["on-restore-confirm", "on-restore-cancel"],
  setup(__props, { emit: __emit }) {

const isLoading = ref(false)
const profiles = inject<Ref<ProfileDTO[]>>('profiles', ref([]))

const onCancel = async () => {
  emits('on-restore-cancel')
}
const emits = __emit

const onSubmit = () => {
  isLoading.value = true
  emits('on-restore-confirm')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(RestoreWizard, {
      title: _ctx.$t('restore_wizard.confirm_profiles'),
      progress: 75
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('restore_wizard.confirm_profiles_question')), 1 /* TEXT */),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(profiles), (profile) => {
          return (_openBlock(), _createElementBlock("div", {
            key: profile.address
          }, [
            (profile.name)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(UserName, {
                    profile: profile,
                    "max-width": 210,
                    "has-at-sign": true,
                    "has-slice-address": true,
                    "name-class": "gradient-text",
                    class: "mb-1"
                  }, null, 8 /* PROPS */, ["profile"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$t('restore_wizard.anonymous_account')), 1 /* TEXT */)),
            _createElementVNode("div", _hoisted_5, _toDisplayString(profile.address), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(Button, {
          variant: "text",
          "is-full-width": true,
          onClick: onCancel,
          "data-testid": "cancel-button"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('qr_code.import_profile.cancel')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(Button, {
          disabled: isLoading.value,
          variant: "primary",
          "is-full-width": true,
          onClick: onSubmit,
          "data-testid": "submit-button"
        }, {
          default: _withCtx(() => [
            _createVNode(SvgIcon, {
              name: "restore-profile",
              color: "var(--neutral-100)",
              class: "mr-2"
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.$t('restore_wizard.restore')), 1 /* TEXT */)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["disabled"])
      ])
    ])
  ]))
}
}

})